import React, {Fragment} from 'react';
import {PendingTransactionsToast} from '~/entities/transactions-history';
import {UserAlertsSection} from '~/features/user-alerts';
import {CardAlertHandlersBatch} from '~/processes/cards';
import {TrtAlertHandlers} from '~/processes/crypto-send-and-receive';

export const alertHandlers = {
    ...CardAlertHandlersBatch,
    ...TrtAlertHandlers,
};

export const fullAlerts = (
    <Fragment>
        <UserAlertsSection handlers={alertHandlers} />
        <PendingTransactionsToast />
    </Fragment>
);
export const demoAlerts = (
    <Fragment>
        <UserAlertsSection />
    </Fragment>
);
